/**
 * DIBAI 18K — Preguntas Fabricaciones
 * assets/preguntas-fabricaciones-dibai.js  v1.0.0
 * Acordeón con animación de altura suave.
 */
(function () {
  'use strict';

  function init(root) {
    const items = Array.from(root.querySelectorAll('.pfab-item'));
    if (!items.length) return;

    function open(item) {
      const trigger = item.querySelector('[data-pfab-trigger]');
      const body    = item.querySelector('.pfab-item__body');
      if (!body) return;

      item.classList.add('pfab-item--open');
      trigger?.setAttribute('aria-expanded', 'true');
      body.removeAttribute('hidden');

      // Animar altura
      const h = body.scrollHeight;
      body.style.maxHeight = '0px';
      body.style.transition = 'max-height 0.35s cubic-bezier(0.4,0,0.2,1)';
      requestAnimationFrame(() => {
        body.style.maxHeight = h + 'px';
      });

      // Limpiar max-height después de la transición
      body.addEventListener('transitionend', () => {
        body.style.maxHeight = '';
        body.style.transition = '';
      }, { once: true });
    }

    function close(item) {
      const trigger = item.querySelector('[data-pfab-trigger]');
      const body    = item.querySelector('.pfab-item__body');
      if (!body) return;

      // Fijar altura actual antes de animar a 0
      body.style.maxHeight = body.scrollHeight + 'px';
      body.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)';

      requestAnimationFrame(() => {
        body.style.maxHeight = '0px';
      });

      body.addEventListener('transitionend', () => {
        body.setAttribute('hidden', '');
        body.style.maxHeight = '';
        body.style.transition = '';
        item.classList.remove('pfab-item--open');
        trigger?.setAttribute('aria-expanded', 'false');
      }, { once: true });
    }

    function toggle(item) {
      if (item.classList.contains('pfab-item--open')) {
        close(item);
      } else {
        // Opcional: cerrar otros (modo acordeón exclusivo)
        // items.forEach(i => { if (i !== item && i.classList.contains('pfab-item--open')) close(i); });
        open(item);
      }
    }

    items.forEach(item => {
      const trigger = item.querySelector('[data-pfab-trigger]');
      trigger?.addEventListener('click', () => toggle(item));
    });

    // El primer item ya está abierto desde el HTML — asegurar max-height correcto
    const firstOpen = items.find(i => i.classList.contains('pfab-item--open'));
    if (firstOpen) {
      const body = firstOpen.querySelector('.pfab-item__body');
      if (body) body.style.maxHeight = '';
    }
  }

  function initAll() {
    document.querySelectorAll('.preguntas-fabricaciones-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.preguntas-fabricaciones-dibai-wrapper')
      || e.target.closest('.preguntas-fabricaciones-dibai-wrapper');
    if (root) init(root);
  });
})();
